
import state from './moduleQuestionnaireState.js';
import mutations from './moduleQuestionnaireMutations.js';
import actions from './moduleQuestionnaireActions.js';
import getters from './moduleQuestionnaireGetters.js';

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
